import Head from 'next/head'
import styles from '../styles/index.module.css'
import { SpSignUpLayout } from '../components/index/signup/SpSignUpLayout';
import Script from 'next/script'
import { ThirdParty } from '../components/index/ThirdParty';

export default function Home() {
  return (
    <>
      <Head>
        <title>Service Provider Sign Up</title>
        <meta charSet="utf-8"/>
        <meta httpEquiv="X-UA-Compatible" content="IE=edge"/>
        <meta name="viewport" content="width=device-width, initial-scale=1, minimum-scale=1.0, maximum-scale=1.0, user-scalable=no"/>
        <meta name="description" content="Sign up as Service Provider and start responding to requests from potential clients."/>
        <meta name="keywords" content="House Rental, Insurance Plan, Personal Trainer, Maid Service, Handyman Service, Aircon Service, Savings Plan, Food Catering, Interior Design, Wedding Planner, Event Planner"/>
        <meta name="author" content="StringsSG"/>
        {/* Account page: crawlable for its links, nothing to rank. */}
        <meta name="robots" content="noindex, follow"/>
        <meta name="google-site-verification" content="JAjj5vAc8Xxrh4idRAchZhYR6rwxWPAk3vxMdx-dwVQ" />
        <meta property="og:url"   content="https://www.stringssg.com" />
        <meta property="og:type"   content="website" />
        <meta property="og:title"    content="Service Provider Sign Up" />
        <meta property="og:description" content="Sign up as Service Provider and start responding to requests from potential clients." />
        <meta property="og:image"  content="https://stringssg-assets.s3-ap-southeast-1.amazonaws.com/static/Google-icon.png" />
        <meta property="og:image:width" content="1200" />
        <meta property="og:image:height" content="630" />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:image" content="https://stringssg-assets.s3-ap-southeast-1.amazonaws.com/static/Google-icon.png" />
        <meta name="twitter:site" content="@stringssg"/> 
        <meta name="twitter:url" content="https://www.stringssg.com/"/>
        <meta name="twitter:title" content="Service Provider Sign Up"/> 
        <meta name="twitter:description" content="Sign up as Service Provider and start responding to requests from potential clients."/>
        <link rel="icon" href="/favicon.ico" />
        <link rel="canonical" href="https://www.stringssg.com/service-provider-signup" />
      </Head>    
        <div className="py-6">
          <SpSignUpLayout/>
          <ThirdParty/>
        </div>
      <Script 
          id="google-tagmanager-new"
          src="https://www.googletagmanager.com/gtag/js?id=G-QD1HGGHDYJ"
          strategy="lazyOnload"
          onLoad={() => {              
            window.dataLayer = window.dataLayer || [];
            function gtag(){dataLayer.push(arguments);}
            gtag('js', new Date());
          
            gtag('config', 'G-QD1HGGHDYJ');
          }} 
        />
    </>
  )
}
